import Cookies from 'js-cookie';

import { LOCALES, DEFAULT_LOCALE } from 'shared/enums/Localization';

const LOCALES_CONVERT: any = {
  en: LOCALES.enUS,
  fr: LOCALES.frFR,
};

export const getLocale = () => {
  const localeFromCookie: any = Cookies.get('locale');

  return LOCALES_CONVERT?.[localeFromCookie] || LOCALES.enUS;
};

export const localizeUrl = (html: string, locale?: string): string => {
  if (!html) {
    return html;
  }
  const re = new RegExp('href=("|\')?((http(s)?://)?(www.)?goat.com(/)?|/)', 'g');
  if (!locale || locale === DEFAULT_LOCALE) {
    return html.replace(re, 'href=$1/');
  }
  return html.replace(re, `href=$1/${locale}/`);
};
